if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async updateFreeGiftProperties(cart) {
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          if (!item.properties?._quote) continue;
          const expectedValue = item.final_line_price === 0 ? "true" : "false";
          if (item.properties?._is_free_gift == expectedValue) {
            continue;
          }
          const response = await fetch(routes.cart_change_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              line: i + 1,
              quantity: item.quantity,
              properties: {
                ...item.properties,
                _is_free_gift: expectedValue,
              },
            }),
          });
          if (!response.ok) {
            throw new Error('Unable to update free gift property');
          }
          const updatedCart = await response.json();
          return this.updateFreeGiftProperties(updatedCart);
        }
        return cart;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const productInfo = this.form.closest('product-info');
        const bundleContainer = productInfo?.querySelector('.ms-bundle');

        const activeBundleView = bundleContainer?.querySelector('#bundleView.active') || bundleContainer?.querySelector('#bundleView_3.active');
        const activeSingleView = bundleContainer?.querySelector('#singleView.active');

        const activeView = activeBundleView || activeSingleView;

        const bundleProductSelectors = activeView?.querySelectorAll(
          '.bundle-product-selector'
        );

        if (bundleProductSelectors?.length) {
          const cards = activeView.querySelectorAll('.card-block');

          const items = Array.from(cards).map((card) => {
            const productSelector = card.querySelector(
              '.bundle-product-selector'
            );

            const selectedOption =
              productSelector.options[productSelector.selectedIndex];

            const nameInput = card.querySelector('.hc-name');
            const addressInput = card.querySelector('.hc-address');
            const placeIdInput = card.querySelector('.hc-placeid');

            const businessNameInput = card.querySelector(
              '.hc-business-name'
            );

            const googlePlaceIdInput = card.querySelector(
              '.hc-google-place-id'
            );

            const bundleTierInput = card.querySelector(
              '.hc-bundle-tier'
            );

            const cardIndexInput = card.querySelector(
              '.hc-card-index'
            );

            const isFreeGiftInput = card.querySelector(
              '.hc-is-free-gift'
            );

            return {
              id: Number(productSelector.value),
              quantity: 1,

              properties: {
                Bedrijfsnaam: nameInput?.value || '',
                Adres: addressInput?.value || '',
                'Google Review Link': placeIdInput?.value || '',

                _quote: selectedOption?.dataset.quote || '',
                _business_name: businessNameInput?.value || '',
                _google_place_id: googlePlaceIdInput?.value || '',
                _bundle_tier: bundleTierInput?.value || '',
                _card_index: cardIndexInput?.value || ''
              },
            };
          });

          const body = {
            items: items,
          };

          if (this.cart) {
            body.sections = this.cart
              .getSectionsToRender()
              .map((section) => section.id);

            body.sections_url = window.location.pathname;

            this.cart.setActiveElement(document.activeElement);
          }

          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(body);
        } else {
          if (this.cart) {
            formData.append(
              'sections',
              this.cart
                .getSectionsToRender()
                .map((section) => section.id)
            );

            formData.append(
              'sections_url',
              window.location.pathname
            );

            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          // .then(async (response) => {
          //   if (response.status) {
          //     return response;
          //   }
          //   const cartResponse = await fetch(`${routes.cart_url}.js`);
          //   await this.updateFreeGiftProperties(await cartResponse.json());
          //   return response;
          // })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');

              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');

              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker(
              'add:wait-for-subscribers'
            );

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              });

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {
                        this.cart.renderContents(response);
                      }
                    );
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {
                  this.cart.renderContents(response);
                }
              );
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            ) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
